import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "row mb-3",
  style: {"display":"flex","flex-direction":"row"}
}
const _hoisted_2 = { style: {"flex":"0 0 66.66%"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"flex":"0 0 33.33%","display":"flex","flex-direction":"column","align-items":"center"} }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"white-space":"nowrap","margin-bottom":"0","font-size":"0.8rem"} }, " Mẫu số 02-VT "),
  /*#__PURE__*/_createElementVNode("p", { style: {"white-space":"nowrap","margin-bottom":"0","font-size":"0.8rem"} }, " (Ban hành theo QĐ số: 200/2014/TT-BTC "),
  /*#__PURE__*/_createElementVNode("p", { style: {"white-space":"nowrap","margin-bottom":"0","font-size":"0.8rem"} }, " Ngày 22/12/2014 của Bộ trưởng BTC) ")
], -1)
const _hoisted_4 = { style: {"text-align":"center","margin-bottom":"2rem"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", { style: {"text-align":"center","font-weight":"bold"} }, " BIÊN BẢN KIỂM NGHIỆM SẢN PHẨM. VẬT TƯ, HÀNG HÓA ", -1)
const _hoisted_6 = { style: {"text-align":"center","margin-bottom":"0","font-style":"italic","color":"#000"} }
const _hoisted_7 = { style: {"text-align":"center","margin-bottom":"0"} }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Biên bản kiểm nghiệm số: ", -1)
const _hoisted_9 = { style: {"text-align":"center","margin-bottom":"0"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "Kho: ", -1)
const _hoisted_11 = {
  class: "pdf-print-table",
  style: {"margin-bottom":"1rem"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "TT"),
    /*#__PURE__*/_createElementVNode("th", null, "Họ và tên"),
    /*#__PURE__*/_createElementVNode("th", null, "Chức vụ chuyên môn"),
    /*#__PURE__*/_createElementVNode("th", null, "Thành phần trong hội đồng")
  ])
], -1)
const _hoisted_13 = { style: {"text-align":"center"} }
const _hoisted_14 = { style: {"text-align":"center"} }
const _hoisted_15 = { style: {"text-align":"center"} }
const _hoisted_16 = { style: {"text-align":"center"} }
const _hoisted_17 = { style: {"margin-bottom":"0","margin-top":"0.75rem"} }
const _hoisted_18 = { style: {"margin-top":"0.75rem"} }
const _hoisted_19 = {
  class: "pdf-print-table",
  style: {"font-size":"0.8rem"}
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      style: {"width":"30px"}
    }, "TT"),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      style: {"width":"150px"}
    }, " Tên, nhãn hiệu, quy cách, phẩm chất vật tư, dụng cụ sản phẩm, hàng hóa "),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      style: {"width":"50px"}
    }, "Mã vật tư"),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      style: {"width":"40px"}
    }, "ĐVT"),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      style: {"width":"100px"}
    }, "Đơn giá"),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      style: {"width":"80px"}
    }, "SL theo hóa đơn"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      style: {"width":"80px"}
    }, "KQ kiểm nghiệm"),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "PT kiểm nghiệm")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"35px"} }, "Đạt"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"35px"} }, "Không đạt")
  ])
], -1)
const _hoisted_21 = { style: {"text-align":"center"} }
const _hoisted_22 = { style: {"text-align":"left"} }
const _hoisted_23 = { style: {"text-align":"left"} }
const _hoisted_24 = { style: {"text-align":"left"} }
const _hoisted_25 = { style: {"text-align":"right"} }
const _hoisted_26 = { style: {"text-align":"right"} }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"center"} }, "✓", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"center"} }, null, -1)
const _hoisted_29 = { style: {"text-align":"center"} }
const _hoisted_30 = { style: {"margin-top":"2rem"} }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("strong", null, "Ý kiến của hội đồng kiểm nghiệm:", -1)
const _hoisted_32 = {
  key: 0,
  style: {"display":"flex","justify-content":"space-around","margin-top":"2rem"}
}
const _hoisted_33 = { style: {"text-align":"center"} }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"center"} }, "(Ký, họ tên)", -1)
const _hoisted_35 = { style: {"text-align":"center","text-transform":"capitalize","margin":"0"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PdfDocumentHeader = _resolveComponent("PdfDocumentHeader")!
  const _component_PdfViewerPage = _resolveComponent("PdfViewerPage")!

  return (_openBlock(), _createBlock(_component_PdfViewerPage, {
    title: "Biên bản kiểm nghiệm",
    "title-suffix": _ctx.bienBanData?.so_bien_ban,
    source: _ctx.pdfSource,
    "file-name": _ctx.pdfFileName,
    loading: _ctx.isGenerating,
    "fallback-route-name": "danh-sach-hop-dong"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref: "printArea",
        class: "bien-ban-viewer__hidden-template",
        style: _normalizeStyle(_ctx.hiddenTemplateStyle),
        "aria-hidden": "true"
      }, [
        (_ctx.bienBanData)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "printing-paper",
              style: _normalizeStyle(_ctx.printPaperStyle)
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_PdfDocumentHeader, {
                    "ten-don-vi": _ctx.tenDonVi,
                    "ten-don-vi-cha": _ctx.tenDonViCha
                  }, null, 8, ["ten-don-vi", "ten-don-vi-cha"])
                ]),
                _hoisted_3
              ]),
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.ngayBienBanDisplay), 1),
                _createElementVNode("p", _hoisted_7, [
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(_ctx.bienBanData.so_bien_ban), 1)
                ]),
                _createElementVNode("p", _hoisted_9, [
                  _hoisted_10,
                  _createTextVNode(" " + _toDisplayString(_ctx.bienBanData.phieu_nhap_kho?.kho?.ten_kho ?? ""), 1)
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("p", null, [
                  _createTextVNode(" Căn cứ theo quyết định của giám đốc "),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.tenGiamDocDisplay), 1),
                  _createTextVNode(" về việc thành lập hội đồng kiểm nghiệm. Hội đồng kiểm nghiệm gồm các ông (bà) có tên sau đây: ")
                ]),
                _createElementVNode("table", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thanhPhanItems, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: index,
                        class: _normalizeClass({
                  'pdf-print-table-data-row': true,
                  'pdf-print-table-data-row--last':
                    index === _ctx.thanhPhanItems.length - 1,
                })
                      }, [
                        _createElementVNode("td", _hoisted_13, _toDisplayString(item.thuTu), 1),
                        _createElementVNode("td", _hoisted_14, _toDisplayString(item.hoTen), 1),
                        _createElementVNode("td", _hoisted_15, _toDisplayString(item.chucVu), 1),
                        _createElementVNode("td", _hoisted_16, _toDisplayString(item.thanhPhan), 1)
                      ], 2))
                    }), 128))
                  ])
                ]),
                _createElementVNode("p", _hoisted_17, [
                  _createTextVNode(" Đã tiến hành kiểm nghiệm các loại vật tư theo hợp đồng số "),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.bienBanData.hop_dong?.so_hop_dong || "......................."), 1),
                  _createTextVNode(" ngày "),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.ngayHopDongDisplay), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("table", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bienBanData.vat_tu_bien_ban_kiem_nghiem, (vatTu, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: index,
                        class: _normalizeClass({
                  'pdf-print-table-data-row': true,
                  'pdf-print-table-data-row--last':
                    index ===
                    _ctx.bienBanData.vat_tu_bien_ban_kiem_nghiem.length - 1,
                })
                      }, [
                        _createElementVNode("td", _hoisted_21, _toDisplayString(index + 1), 1),
                        _createElementVNode("td", _hoisted_22, _toDisplayString(vatTu.ten_vat_tu), 1),
                        _createElementVNode("td", _hoisted_23, _toDisplayString(vatTu.ma_vat_tu), 1),
                        _createElementVNode("td", _hoisted_24, _toDisplayString(vatTu.don_vi_tinh ? vatTu.don_vi_tinh : "-"), 1),
                        _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.donGiaVatTuDisplay(vatTu)), 1),
                        _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.formatQuantity(vatTu.pivot.so_luong)), 1),
                        _hoisted_27,
                        _hoisted_28,
                        _createElementVNode("td", _hoisted_29, _toDisplayString(vatTu.pivot.phuong_thuc_kiem_nghiem
                      ? vatTu.pivot.phuong_thuc_kiem_nghiem
                      : "-"), 1)
                      ], 2))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("p", null, [
                  _hoisted_31,
                  _createTextVNode(" " + _toDisplayString(_ctx.bienBanData.y_kien), 1)
                ])
              ]),
              (!!_ctx.bienBanData.thanh_phan_hoi_dong && _ctx.thanhPhanItems.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thanhPhanItems, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        style: {"display":"inline-flex","flex-direction":"column","align-items":"center","justify-content":"space-between","height":"120px"}
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h6", _hoisted_33, "Thành phần " + _toDisplayString(item.thuTu), 1),
                          _hoisted_34
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("p", _hoisted_35, _toDisplayString(item.hoTen), 1)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 4))
          : _createCommentVNode("", true)
      ], 4)
    ]),
    _: 1
  }, 8, ["title-suffix", "source", "file-name", "loading"]))
}